var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootballField(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 800,
    viewBox: "0 0 504 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504 800L504 0L-3.05176e-05 -2.20305e-05L-6.54867e-05 800L504 800Z",
    fill: "url(#paint0_radial_531_123)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.11,
    y: 102,
    width: 504,
    height: 75,
    fill: "#004202"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.11,
    y: 227,
    width: 504,
    height: 75,
    fill: "#004202"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.11,
    y: 352,
    width: 504,
    height: 75,
    fill: "#004202"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.11,
    y: 477,
    width: 504,
    height: 75,
    fill: "#004202"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.11,
    y: 602,
    width: 504,
    height: 75,
    fill: "#004202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90164 782.248L8.90167 17.7543L493.988 17.7543L493.988 782.248L8.90164 782.248ZM13.352 21.083L13.352 777.81L490.65 777.81L490.65 21.083L13.352 21.083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.622 782.247L134.622 687.934L368.265 687.934L368.265 782.247L134.622 782.247ZM139.073 691.262L139.073 778.918L364.927 778.918L364.927 691.262L139.073 691.262Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.178 793.344L219.178 777.81L284.82 777.81L284.82 793.344L219.178 793.344ZM222.516 782.248L222.516 790.015L280.37 790.015L280.37 782.248L222.516 782.248Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.689 399.5C173.689 356.486 209.317 321 252.502 321C295.687 321 331.315 356.486 331.315 399.5C331.315 442.514 295.687 478 252.502 478C208.237 478 173.689 443.589 173.689 399.5ZM326.996 399.5C326.996 358.637 293.528 325.301 252.502 325.301C211.476 325.301 178.008 358.637 178.008 399.5C178.008 440.363 211.476 473.699 252.502 473.699C293.528 474.774 326.996 441.438 326.996 399.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.767 399.443C244.767 396.115 248.105 392.786 251.443 392.786C254.78 392.786 258.118 396.115 258.118 399.443C258.118 402.772 254.78 406.101 251.443 406.101C248.105 406.101 244.767 403.882 244.767 399.443Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M492.874 401.663L492.874 398.334L11.1256 398.334L11.1256 401.663L492.874 401.663Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.622 112.068L134.622 17.7543L368.265 17.7543L368.265 112.068L134.622 112.068ZM139.073 21.083L139.073 108.739L364.927 108.739L364.927 21.083L139.073 21.083Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.178 21.0827L219.178 6.65832L284.821 6.65833L284.821 22.1923L219.178 22.1923L219.178 21.0827ZM222.516 9.98703L222.516 17.754L280.37 17.754L280.37 9.98704L222.516 9.98703Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_531_123",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.902 399.949) rotate(90) scale(739.906 699.721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82D748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3505,
    stopColor: "#529D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7898,
    stopColor: "#195A0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9963,
    stopColor: "#034002"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballField);
export default __webpack_public_path__ + "static/media/football_field.7cba7912de9b2419ff8fd92d9cd4c703.svg";
export { ForwardRef as ReactComponent };